import { Slideout, Icon, Card, CardPanel, IconHighlight, Avatar, Typography, Button, CircularProgress } from "@ann/web-components";
import ModelSelector from "../../pages/Overview/components/ModelSelector/ModelSelector";
import { ContactSlideOutContainer, LeftSlotWrapper, ContactWidgetContainer, ContactTopContent, ContactTopLeftContent, ContactBottomContent, ContactBottomLeftContent, ContactBottomLeftItem, ContactBottomRightContent } from "./ContactSlideout.styled";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useContacts } from "../../context/ContactsContext";

const ContactWidget = ({ contactData, loading }) => {
    if (loading) {
        return (
            <Card size='large'>
                <CardPanel isExpandable={true} openDefault={true}>
                    <CardPanel.Header title='Contact information'>
                        <CardPanel.Header.LeftSlot>
                            <LeftSlotWrapper>
                                <Icon name='dragIndicator' size='medium' />
                                <IconHighlight icon='person' bgColor='primary' iconColor='primary' size='medium' />
                            </LeftSlotWrapper>
                        </CardPanel.Header.LeftSlot>
                    </CardPanel.Header>
                    <CardPanel.Content>
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                            <CircularProgress size="large" />
                        </div>
                    </CardPanel.Content>
                </CardPanel>
            </Card>
        );
    }

    if (!contactData) {
        return (
            <Card size='large'>
                <CardPanel isExpandable={true} openDefault={true}>
                    <CardPanel.Header title='Contact information'>
                        <CardPanel.Header.LeftSlot>
                            <LeftSlotWrapper>
                                <Icon name='dragIndicator' size='medium' />
                                <IconHighlight icon='person' bgColor='primary' iconColor='primary' size='medium' />
                            </LeftSlotWrapper>
                        </CardPanel.Header.LeftSlot>
                    </CardPanel.Header>
                    <CardPanel.Content>
                        <Typography category='body' weight='regular' size='small'>No contact data available</Typography>
                    </CardPanel.Content>
                </CardPanel>
            </Card>
        );
    }

    const fullAddress = [
        contactData.address?.addressLine,
        contactData.address?.addressCity,
        contactData.address?.addressState
    ].filter(Boolean).join(', ');

    return (
        <Card size='large'>
            <CardPanel isExpandable={true} openDefault={true}>
                <CardPanel.Header title='Contact information'>
                    <CardPanel.Header.LeftSlot>
                        <LeftSlotWrapper>
                            <Icon name='dragIndicator' size='medium' />
                            <IconHighlight icon='person' bgColor='primary' iconColor='primary' size='medium' />
                        </LeftSlotWrapper>
                    </CardPanel.Header.LeftSlot>
                </CardPanel.Header>
                <CardPanel.Content>
                    <ContactWidgetContainer>
                        <ContactTopContent>
                            <Avatar src='https://i.pravatar.cc/40' height={56} width={56} />
                            <ContactTopLeftContent>
                                <Typography category='title' weight='bold' size='large'>{contactData.legalName}</Typography>
                                <Typography category='body' weight='regular' size='small'>Contact Information</Typography>
                            </ContactTopLeftContent>
                        </ContactTopContent>
                        <ContactBottomContent>
                            <ContactBottomLeftContent>
                                {contactData.phone && (
                                    <ContactBottomLeftItem>
                                        <Icon name='sms' size='small' />
                                        <Typography category='body' weight='regular' size='small'>{contactData.phone}</Typography>
                                    </ContactBottomLeftItem>
                                )}
                                {contactData.email && (
                                    <ContactBottomLeftItem>
                                        <Icon name='inbox' size='small' />
                                        <Typography category='body' weight='regular' size='small'>{contactData.email}</Typography>
                                    </ContactBottomLeftItem>
                                )}
                                {fullAddress && (
                                    <ContactBottomLeftItem>
                                        <Icon name='locationOn' size='small' />
                                        <Typography category='body' weight='regular' size='small'>{fullAddress}</Typography>
                                    </ContactBottomLeftItem>
                                )}
                                {contactData.address?.addressPostalCode && (
                                    <ContactBottomLeftItem>
                                        <Icon name='tag' size='small' />
                                        <Typography category='body' weight='regular' size='small'>{contactData.address.addressPostalCode}</Typography>
                                    </ContactBottomLeftItem>
                                )}
                            </ContactBottomLeftContent>
                            <ContactBottomRightContent>
                                <Icon name='edit' size='medium' />
                            </ContactBottomRightContent>
                        </ContactBottomContent>
                    </ContactWidgetContainer>
                </CardPanel.Content>
            </CardPanel>
        </Card>
    );
}

const ContactSlideOut = ({ open, onClose, contactUuid }) => {
    const navigate = useNavigate();
    const { contactDetails, loadingDetails, fetchContactDetails } = useContacts();

    useEffect(() => {
        if (open && contactUuid) {
            fetchContactDetails(contactUuid);
        }
    }, [open, contactUuid, fetchContactDetails]);

    return (
        <Slideout
            open={open}
            onClose={onClose}
        >
            <Slideout.HeaderActions>
                <Icon name='arrowLeft' size='medium' />
            </Slideout.HeaderActions>
            <Slideout.Header>
                <Slideout.Title value='Preview' />
                <Slideout.Subtitle value='Overview of this contact' />
            </Slideout.Header>
            <Slideout.Content>
                <ContactSlideOutContainer>
                    <ContactWidget contactData={contactDetails} loading={loadingDetails} />
                    <ModelSelector contactId={contactUuid} />
                </ContactSlideOutContainer>
            </Slideout.Content>
            <Slideout.Actions>
                <Button
                    label="View Contact"
                    size="medium"
                    type="primary"
                    onClick={() => navigate(`/v1/ucp/${contactUuid}/overview`)}
                    disabled={!contactUuid}
                />
            </Slideout.Actions>
        </Slideout>
    );
}

export default ContactSlideOut;
